import {
  CarePlanApi,
  ClinicalAlertsApi,
  EligiblesApi,
  MedicationApi,
  PartnerApi,
  PatientsApi,
} from "patients-experience-client";
import { createCommonConfigurationForApis } from "./CommonHelper";
import { spire360ApiClient } from "./Spire360ApiClient";
import { AxiosInstance } from "axios";

export function createPatientApi(): PatientsApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_PATIENTS_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient;
    return new PatientsApi(
      undefined,
      `${process.env.REACT_APP_PATIENTS_API_URL_GATEWAY}`,
      axiosInstance,
      // createCommonConfigurationForApis(),
      // "http://localhost:4020"
    );
  } else {
    return new PatientsApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_PATIENTS_API_URL}`,
      // "http://localhost:4020"
    );
  }
}

export function createClinicalAlertsApi(): ClinicalAlertsApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_PATIENTS_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient;
    return new ClinicalAlertsApi(
      undefined,
      `${process.env.REACT_APP_PATIENTS_API_URL_GATEWAY}`,
      axiosInstance,
      // createCommonConfigurationForApis(),
      // "http://localhost:4020"
    );
  } else {
    return new ClinicalAlertsApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_PATIENTS_API_URL}`,
      // "http://localhost:4020"
    );
  }
}

export function createPartnerApi(): PartnerApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_PATIENTS_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient;
    return new PartnerApi(
      undefined,
      `${process.env.REACT_APP_PATIENTS_API_URL_GATEWAY}`,
      axiosInstance,
      // "http://localhost:4020"
    );
  } else {
    return new PartnerApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_PATIENTS_API_URL}`,
      // "http://localhost:4020"
    );
  }
}

export function createCarePlanApi(): CarePlanApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_PATIENTS_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient;
    return new CarePlanApi(
      undefined,
      `${process.env.REACT_APP_PATIENTS_API_URL_GATEWAY}`,
      axiosInstance,
      // createCommonConfigurationForApis(),
      // "http://localhost:4020"
    );
  } else {
    return new CarePlanApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_PATIENTS_API_URL}`,
      // "http://localhost:4020"
    );
  }
}

export function createMedicationApi(): MedicationApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";
  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_MEDICATION_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient;
    return new MedicationApi(
      undefined,
      `${process.env.REACT_APP_PATIENTS_API_URL_GATEWAY}`,
      axiosInstance,
    );
  } else {
    return new MedicationApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_PATIENTS_API_URL}`,
    );
  }
}

export function createEligiblesApi(): EligiblesApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_PATIENTS_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient;
    return new EligiblesApi(
      undefined,
      `${process.env.REACT_APP_PATIENTS_API_URL_GATEWAY}`,
      axiosInstance,
    );
  } else {
    return new EligiblesApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_PATIENTS_API_URL}`,
    );
  }
}
